import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { SimulationPageComponent } from './simulation-page/simulation-page.component'
import { SimulationWarningsDetailsComponent } from './components/simulation-warnings-components/simulation-warnings-details/simulation-warnings-details.component'
import { SimulationWarningsEditorComponent } from './components/simulation-warnings-editor/simulation-warnings-editor.component'
import { SimulationCreateWarningsDetailsComponent } from './components/simulation-warnings-components/simulation-create-warnings-details/simulation-create-warnings-details.component'
import { SimulationCreateAreaWarningsDetailsComponent } from './components/simulation-warnings-components/simulation-create-area-warnings-details/simulation-create-area-warnings-details.component'
import { SimulationAreaWarningsDetailsComponent } from './components/simulation-warnings-components/simulation-area-warnings-details/simulation-area-warnings-details.component'
import { SimulationLayerConfigComponent } from './components/simulation-layer-config/simulation-layer-config.component'
import { SimulationDataComponent } from './components/simulation-layer-categories/simulation-data.component'
import { AdvancedSettingsComponent } from './components/simulation-advanced-settings/advanced-settings.component'
import { SharedModule } from '../shared/shared.module'
import { DetailsAccordionComponent } from '../shared/components/details/details-accordion/details-accordion'
import { NgbTooltipModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'
import { RbUiComponentsModule } from '@inst-iot/bosch-angular-ui-components'
import { SimulationViewActionsRemoveAllSimulations } from './components/simulation-navigation-bar/simulation-view-actions-remove-simulations/simulation-view-actions-remove-simulations.component'
import { SimulationViewActionsBarComponent } from './components/simulation-navigation-bar/simulation-view-actions-bar/simulation-view-actions-bar.component'
import { SimulationEditorIntroDialogComponent } from './components/simulation-editor-intro-dialog/simulation-editor-intro-dialog.component'
import { SimulationWarningsEditorDataService } from './services/simulation-warnings-editor-data.service'
import { SimulationWarningsLegacyImportService } from './services/simulation-warnings-legacy-import.service'

@NgModule({
  declarations: [
    SimulationPageComponent,
    SimulationDataComponent,
    SimulationWarningsDetailsComponent,
    SimulationWarningsEditorComponent,
    SimulationCreateAreaWarningsDetailsComponent,
    SimulationAreaWarningsDetailsComponent,
    SimulationCreateWarningsDetailsComponent,
    SimulationLayerConfigComponent,
    SimulationViewActionsRemoveAllSimulations,
    SimulationViewActionsBarComponent,
    SimulationEditorIntroDialogComponent,
    AdvancedSettingsComponent,
  ],
  imports: [
    CommonModule,
    RbUiComponentsModule,
    NgbTooltipModule,
    NgbDropdownModule,
    DragDropModule,
    FormsModule,
    SharedModule,
    DetailsAccordionComponent,
  ],
  providers: [SimulationWarningsEditorDataService, SimulationWarningsLegacyImportService],
})
export class SimulationModule {}
